<template>
        <div class="max-w-3xl mx-auto bg-white border border-gray-300 rounded-lg shadow-lg px-6 py-4 mt-5">
            
            <div class="px-6 py-4 flex space-x-4">
                <button 
                    v-for="tab in tabs" :key="tab.value"
                    class="px-6 py-2 rounded-full shadow-md font-semibold"
                    :class="activeTab === tab.value ? 'bg-blue-500 text-white' : 'bg-gray-300 text-gray-700'"
                    @click="activeTab = tab.value">
                    {{ tab.label }}
                </button>
            </div>

            <div v-if="loading" class="flex justify-center items-center h-32">
                <div class="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500 border-opacity-75"></div>
                <p class="ml-3 text-gray-600">Fetching details...</p>
            </div>

            <div v-else>
                <div v-if="activeTab === 'deposits'">
                    <table class="w-full mt-4 border-collapse">
                        <thead>
                            <tr class="bg-gray-200 text-gray-800 ">
                                <th class="p-3 rounded-tl-lg">Name</th>
                                <th class="p-3 border">Account No</th>
                                <th class="p-3 rounded-tr-lg">Amount</th>
                            </tr>
                        </thead>
                        <tbody v-if="deposits.length">
                            <tr v-for="(deposit, index) in deposits" :key="index">
                                <td class="p-3 ">{{ deposit.type_desc }}</td>
                                <td class="p-3 ">{{ deposit.cbsac }}</td>
                                <td class="p-3">₹{{ deposit.amount }}</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="4" class="p-4 text-center text-gray-500">No Deposits data available</td>
                            </tr>
                        </tbody>
                    </table>
                </div>


                <div v-if="activeTab === 'pigmy'">
                    <table class="w-full mt-4 border-collapse">
                        <thead>
                            <tr class="bg-gray-200 text-gray-800 ">
                                <th class="p-3 rounded-tl-lg">Name</th>
                                <th class="p-3 rounded-tr-lg">Amount</th>
                            </tr>
                        </thead>
                        <tbody v-if="pigmy.length">
                            <tr v-for="(pigmy, index) in pigmy" :key="index">
                                <td class="p-3">{{ pigmy.type_desc }}</td>
                                <td class="p-3">₹{{ pigmy.amount }}</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="4" class="p-4 text-center text-gray-500">No Pigmy data available</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

        </div>
</template>

<script>
import { apiRequest } from '@/api';

export default {
    name: "TermDeposits",
    data() {
        return {
            activeTab: "deposits",
            deposits: [],
            pigmy: [],
            loading: false,
            tabs: [
                { label: "Deposits", value: "deposits" },
                { label: "Pigmy", value: "pigmy" },
            ]
        };
    },
    props: {
        user: Object
    },
    created() {
        this.fetchTermDeposits();
    },
    methods: {
        async fetchTermDeposits() {
            this.loading = true;

            try {
                const response = await apiRequest('/deposits', 'POST',{
                    type: 0
                });

                if (response.data.status === 'success') {
                    this.deposits = response.data.deposits || [];
                    this.pigmy = response.data.pigmy || [];
                }
            } catch (error) {
                console.error("Error fetching term deposits:", error);
            } finally{
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>

table {
    border-radius: 10px;
    overflow: hidden;
}

button {
    transition: all 0.3s ease;
}
button:hover {
    background-color: #4a90e2 !important;
    color: white !important;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.animate-spin {
    animation: spin 1s linear infinite;
}

</style>
